import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _ctx.locale }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "centralSectionBox",
        style: _normalizeStyle({ zoom: _ctx.zoomSize })
      }, [
        _createVNode(_component_router_view)
      ], 4)
    ]),
    _: 1
  }, 8, ["locale"]))
}